export default function getFileExtension(filename: string): string {
  if (!filename) return '';
  const file = filename?.split('.');
  return file[file.length - 1];
}
